/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getPoolFeeParametersDecoder,
  getPoolFeeParametersEncoder,
  type PoolFeeParameters,
  type PoolFeeParametersArgs,
} from "./index.js";

export type StaticConfigParameters = {
  poolFees: PoolFeeParameters;
  sqrtMinPrice: bigint;
  sqrtMaxPrice: bigint;
  vaultConfigKey: Address;
  poolCreatorAuthority: Address;
  activationType: number;
  collectFeeMode: number;
};

export type StaticConfigParametersArgs = {
  poolFees: PoolFeeParametersArgs;
  sqrtMinPrice: number | bigint;
  sqrtMaxPrice: number | bigint;
  vaultConfigKey: Address;
  poolCreatorAuthority: Address;
  activationType: number;
  collectFeeMode: number;
};

export function getStaticConfigParametersEncoder(): Encoder<StaticConfigParametersArgs> {
  return getStructEncoder([
    ["poolFees", getPoolFeeParametersEncoder()],
    ["sqrtMinPrice", getU128Encoder()],
    ["sqrtMaxPrice", getU128Encoder()],
    ["vaultConfigKey", getAddressEncoder()],
    ["poolCreatorAuthority", getAddressEncoder()],
    ["activationType", getU8Encoder()],
    ["collectFeeMode", getU8Encoder()],
  ]);
}

export function getStaticConfigParametersDecoder(): Decoder<StaticConfigParameters> {
  return getStructDecoder([
    ["poolFees", getPoolFeeParametersDecoder()],
    ["sqrtMinPrice", getU128Decoder()],
    ["sqrtMaxPrice", getU128Decoder()],
    ["vaultConfigKey", getAddressDecoder()],
    ["poolCreatorAuthority", getAddressDecoder()],
    ["activationType", getU8Decoder()],
    ["collectFeeMode", getU8Decoder()],
  ]);
}

export function getStaticConfigParametersCodec(): Codec<
  StaticConfigParametersArgs,
  StaticConfigParameters
> {
  return combineCodec(
    getStaticConfigParametersEncoder(),
    getStaticConfigParametersDecoder(),
  );
}
